import React from 'react';

import { Timeline } from '@mui/lab';
import { Typography, CircularProgress } from '@mui/material';

import { useSelector, useDispatch } from 'react-redux';
import {
  selectIsLoadingEpisodes,
  selectYear,
} from '../../store/episodes/episodes.selector';
import { changeEpisodeTimelineVisible } from '../../store/ui/ui.slice';
import { selectUseHurricaneApi } from '../../store/options/options.selector';

import Section from '../section/section.component';
import CloseBtn from '../close-btn/close-btn.component';

import './episodes-timeline.styles.scss';
import EpisodeItems from '../episode-items/episode-items.components';
import HurricaneItems from '../hurricane-items/hurricane-items.component';

export default function EpisodesTimeline() {
  const dispatch = useDispatch();
  const year = useSelector(selectYear);
  const loading = useSelector(selectIsLoadingEpisodes);

  const useHurricaneApi = useSelector(selectUseHurricaneApi);

  const handleClose = () => {
    dispatch(changeEpisodeTimelineVisible(false));
  };

  return (
    <Section className='episodes-timeline-container'>
      <Typography
        variant='h3'
        sx={{
          fontSize: '22px',
          textAlign: 'center',
          marginBottom: '0px',
          marginLeft: '12px',
        }}
      >
        {year}
      </Typography>
      {loading ? (
        <div className='circle-loading'>
          <CircularProgress />
        </div>
      ) : (
        <Timeline
          sx={{
            margin: 0,
            padding: '0px 10px 0px 4px',
            height: 'calc(100% - 26px)',
            overflow: 'auto',
          }}
        >
          {useHurricaneApi ? <HurricaneItems /> : <EpisodeItems />}
        </Timeline>
      )}
      <CloseBtn handleClose={handleClose} />
    </Section>
  );
}
